import { SCHEMA } from '@vedalib/editor/lib/brand'
import React, { useCallback, useMemo } from 'react'

import Padding from 'components/Editor/Toolbar/Padding'
import { LayoutScroll } from 'components/LayoutPage'
import { Typography } from 'components/uiKit/Typography'
import {
  BrandButtonFont,
  BrandFormFontBase,
  BrandGoBack,
  BrandRichTextFontForms,
  BrandRichTextTypography,
} from 'services/Branding/components'
import { FONT_FIELDS } from 'services/Branding/fieldConfigs'
import { genSchema } from 'services/Branding/genSchema'
import { useElementFontCss, useElementFontValues, useUpdateSchema } from 'services/Branding/hooks'
import { BrandFormEnum } from 'services/Branding/types'
import { t } from 'services/Translation'

import type { ListFormBrandType } from './listTypes'

const FONT_FORM_SCHEMA = genSchema(SCHEMA.list.font, {
  ...FONT_FIELDS,
  numbering: FONT_FIELDS.base,
})

const TypographyNumbering: ListFormBrandType = ({ setForm, device, subConfigs }) => {
  const fontPath = useMemo(() => ['font', device], [device])
  const fontSchema = useUpdateSchema(fontPath, subConfigs, FONT_FORM_SCHEMA)

  const handleSetTypography = useCallback(() => setForm?.(BrandFormEnum.TYPOGRAPHY), [setForm])

  return (
    <BrandFormFontBase font={fontSchema.numbering}>
      <BrandGoBack onClick={handleSetTypography}>
        <Typography weight='medium'>{t('elements.list.tags.numbering')}</Typography>
      </BrandGoBack>
      <Typography styleType='hint'>{t('page.brand.fonts.inheritHint')}</Typography>
    </BrandFormFontBase>
  )
}

const ListTypography: ListFormBrandType = ({ element, edited, device, setForm }) => {
  const { font } = element || {}
  const values = useElementFontValues('list', device, font)
  const styles = useElementFontCss('list', device, font)

  const goBack = useCallback(() => setForm?.(BrandFormEnum.STYLE), [setForm])

  return (
    <LayoutScroll sizeAutoCapable>
      <Padding bottomSpace gap sides>
        <BrandGoBack onClick={goBack}>
          <Typography weight='medium'>{t('page.brand.tab.typography')}</Typography>
        </BrandGoBack>
        <BrandButtonFont
          edited={edited.font?.numbering}
          font='numbering'
          onClick={setForm}
          styles={styles.numbering}
          values={values.numbering}
        >
          {t('elements.list.tags.numbering')}
        </BrandButtonFont>
        <BrandRichTextTypography
          edited={edited.font}
          setActiveFont={setForm}
          styles={styles}
          values={values}
        />
      </Padding>
    </LayoutScroll>
  )
}

const FONTS_FORM_MAP = {
  [BrandFormEnum.TYPOGRAPHY]: ListTypography,
  numbering: TypographyNumbering,
  ...BrandRichTextFontForms,
}

export default FONTS_FORM_MAP
